// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var ErrorComponent = require("../../reason/common/Error/ErrorComponent.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
var ProfilePageSocialMediaForm = require("./ProfilePageSocialMediaForm.bs.js");
var ProfilePageProfilePhotoForm = require("./ProfilePageProfilePhotoForm.bs.js");
var ProfilePageRelayQuery_graphql = require("../../__generated__/ProfilePageRelayQuery_graphql.bs.js");
var ProfilePageAddressInformationForm = require("./ProfilePageAddressInformationForm.bs.js");
var ProfilePagePersonalInformationForm = require("./ProfilePagePersonalInformationForm.bs.js");
var ProfilePageBiographyInformationForm = require("./ProfilePageBiographyInformationForm.bs.js");

var convertVariables = ProfilePageRelayQuery_graphql.Internal.convertVariables;

var convertResponse = ProfilePageRelayQuery_graphql.Internal.convertResponse;

var convertWrapRawResponse = ProfilePageRelayQuery_graphql.Internal.convertWrapRawResponse;

var use = RescriptRelay_Query.useQuery(convertVariables, ProfilePageRelayQuery_graphql.node, convertResponse);

var useLoader = RescriptRelay_Query.useLoader(convertVariables, ProfilePageRelayQuery_graphql.node, (function (prim) {
        return prim;
      }));

var usePreloaded = RescriptRelay_Query.usePreloaded(ProfilePageRelayQuery_graphql.node, convertResponse, (function (prim) {
        return prim;
      }));

var $$fetch = RescriptRelay_Query.$$fetch(ProfilePageRelayQuery_graphql.node, convertResponse, convertVariables);

var fetchPromised = RescriptRelay_Query.fetchPromised(ProfilePageRelayQuery_graphql.node, convertResponse, convertVariables);

var retain = RescriptRelay_Query.retain(ProfilePageRelayQuery_graphql.node, convertVariables);

var Query = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  $$fetch: $$fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

function ProfilePageRelay(props) {
  var data = use(undefined, undefined, undefined, undefined);
  var agent = data.currentlyLoggedInAgent;
  if (agent !== undefined) {
    return JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsx(ProfilePagePersonalInformationForm.make, {
                              agent: agent.fragmentRefs
                            })
                      }),
                  JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsx(ProfilePageProfilePhotoForm.make, {
                              agent: agent.fragmentRefs
                            })
                      }),
                  JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsx(ProfilePageAddressInformationForm.make, {
                              agent: agent.fragmentRefs
                            })
                      }),
                  JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsx(ProfilePageBiographyInformationForm.make, {
                              agent: agent.fragmentRefs
                            })
                      }),
                  JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsx(ProfilePageSocialMediaForm.make, {
                              agent: agent.fragmentRefs
                            })
                      })
                ]
              });
  } else {
    return JsxRuntime.jsx(ErrorComponent.make, {
                message: "No data. Please refresh or try again later..."
              });
  }
}

var make = ProfilePageRelay;

exports.Query = Query;
exports.make = make;
/* use Not a pure module */
